/** A client-supplied clock time, normalized for the reservation form and AI summaries. */
export function normalizeTime(value) {
  const match = /^(\d{1,2}):(\d{2})\s*([ap])?\.?m?\.?$/i.exec(String(value ?? '').trim());
  if (!match) return null;
  let hours = Number(match[1]);
  const minutes = Number(match[2]);
  const meridiem = match[3] ? match[3].toLowerCase() : null;
  if (minutes > 59) return null;
  if (meridiem) {
    if (hours < 1 || hours > 12) return null;
    if (meridiem === 'p' && hours < 12) hours += 12;
    if (meridiem === 'a' && hours === 12) hours = 0;
  } else if (hours > 23) {
    return null;
  }

  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
}

/** The UTC instant (ms) for a wall-clock date + time in an IANA time zone. */
export function zonedToInstant(date, time, timeZone = 'America/New_York') {
  const [year, month, day] = date.split('-').map(Number);
  const [hours, minutes] = time.split(':').map(Number);
  const guess = Date.UTC(year, month - 1, day, hours, minutes);
  const offsetAt = (instant) => {
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone, hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit',
    }).formatToParts(new Date(instant)).reduce((acc, part) => ({ ...acc, [part.type]: part.value }), {});
    return Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day), Number(parts.hour), Number(parts.minute), Number(parts.second)) - instant;
  };
  let instant = guess - offsetAt(guess);
  instant = guess - offsetAt(instant); // second pass settles daylight-saving edges
  return instant;
}
